<ng-container *transloco="let t">
  <td iTableTd>
    <div class="flex items-center gap-4">
      @if (!isReadOnly()) {
        <ICheckbox [(value)]="isRowSelected" (click)="$event.stopPropagation()" />
      }
      {{ productGroup().productGroupName }}
    </div>
  </td>
  <td iTableTd>{{ productGroup().items.length }}</td>
  <td iTableTd>
    <div class="flex w-full justify-end">
      @if (!isReadOnly()) {
        <button
          iButton
          [iDropdownMenuTrigger]="rowMenu"
          color="gray"
          variant="ghost"
          size="sm"
          class="opacity-0 group-hover:opacity-100"
          placement="bottom-end"
          (click)="$event.preventDefault(); $event.stopPropagation()"
        >
          <IIcon name="ellipsis" />
        </button>
      }
    </div>
    <ng-template #rowMenu>
      <IDropdownMenu class="w-[120px]">
        <button iDropdownMenuItem variant="danger" (click)="deleteProductGroup()">
          <IIcon name="trash" />
          {{ t("common.delete") }}
        </button>
      </IDropdownMenu>
    </ng-template>
  </td>
</ng-container>
